export type size = 'extra-small' | 'small' | 'medium' | 'large' | 'extra-large';

export interface IIconProps {
  className?: string;
  size?: size;
}

export const sizeMap = {
  'extra-small': { width: 12, strokeWidth: 0.8 },
  small: { width: 18, strokeWidth: 0.8 },
  medium: { width: 24, strokeWidth: 0.8 },
  large: { width: 34, strokeWidth: 0.8 },
  'extra-large': { width: 80, strokeWidth: 0.8 },
};
